/**
 * DEV-ONLY: Experimental smart / schema-oriented inspector shell (read-only first pass).
 * Shares selection + layout summary with LayoutInspectorGlobal; no edit pipeline yet.
 */
import React from "react";
import "./LayoutInspector.css";

function Row({ label, value }) {
  if (value == null || value === "") return null;
  return (
    <div className="layout-inspector-panel__row">
      <span className="layout-inspector-panel__label">{label}</span>
      <span className="layout-inspector-panel__value" title={String(value)}>
        {String(value)}
      </span>
    </div>
  );
}

export default function SmartInspectorPanel({
  layoutInfo,
  introspection,
  showHoverOverlay,
  onToggleHoverOverlay,
  onClearSelection,
  onClose,
}) {
  return (
    <div className="layout-inspector-panel" aria-label="Smart inspector (experimental)">
      <div className="layout-inspector-panel__section">
        <div className="layout-inspector-panel__tune-title">Overview</div>
        <p className="layout-inspector-panel__tune-hint">
          Experimental panel: schema-driven controls will land here. Selection and highlights match the classic inspector.
        </p>
      </div>

      {layoutInfo ? (
        <div className="layout-inspector-panel__section">
          <div className="layout-inspector-panel__tune-title">Selection</div>
          <Row label="Tag" value={layoutInfo.tagName} />
          <Row label="Class" value={layoutInfo.className || "(none)"} />
          <Row label="Size" value={`${layoutInfo.width} × ${layoutInfo.height}`} />
        </div>
      ) : (
        <p className="layout-inspector-panel__hint">Click an element to select it.</p>
      )}

      {introspection && (
        <div className="layout-inspector-panel__section layout-inspector-panel__media-comp">
          <div className="layout-inspector-panel__tune-title">CSS custom properties</div>
          <p className="layout-inspector-panel__tune-hint">Inline `--*` declarations on the selected element (read-only).</p>
          <pre className="layout-inspector-panel__smart-pre">
            {Object.keys(introspection.inlineCustomProperties).length === 0
              ? "(none)"
              : JSON.stringify(introspection.inlineCustomProperties, null, 2)}
          </pre>
          <p className="layout-inspector-panel__tune-hint layout-inspector-panel__tune-hint--spaced">
            Computed values for those names:
          </p>
          <pre className="layout-inspector-panel__smart-pre">
            {Object.keys(introspection.computedCustomProperties).length === 0
              ? "(none)"
              : JSON.stringify(introspection.computedCustomProperties, null, 2)}
          </pre>
        </div>
      )}

      {layoutInfo && (
        <div className="layout-inspector-panel__section layout-inspector-panel__media-comp">
          <div className="layout-inspector-panel__tune-title">Schema (placeholder)</div>
          <p className="layout-inspector-panel__tune-hint">Future: element-type schema, bound controls, validation.</p>
        </div>
      )}

      <div className="layout-inspector-panel__actions">
        <label className="layout-inspector-panel__checkbox">
          <input
            type="checkbox"
            checked={showHoverOverlay}
            onChange={(e) => onToggleHoverOverlay(e.target.checked)}
          />
          <span>Hover highlight</span>
        </label>
        <button type="button" className="layout-inspector-panel__btn" onClick={onClearSelection}>
          Clear selection
        </button>
        <button type="button" className="layout-inspector-panel__btn layout-inspector-panel__btn--primary" onClick={onClose}>
          Close inspector
        </button>
      </div>
    </div>
  );
}
